const COLLECTION_BAR_DENSITIES = {
  4: { desktop: 4, tabletDown: 2 },
  2: { desktop: 2, tabletDown: 1 },
};

const COLLECTION_BAR_DENSITY_KEY = 'collection-bar:density';

class CollectionBar extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header') || document.getElementById('shopify-section-header');
    this.filterButton = this.querySelector('[data-collection-bar-filter]');
    this.gridButton = this.querySelector('[data-collection-bar-grid]');

    this.syncOffset = this.syncOffset.bind(this);
    this.onScroll = this.onScroll.bind(this);

    this.lastOffset = null;
    this.ticking = false;
    this.syncOffset();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });

    if (this.filterButton) this.setUpFilterToggle();
    if (this.gridButton) this.setUpGridToggle();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this.gridObserver) this.gridObserver.disconnect();
  }

  /* Keep the bar pinned directly beneath the header, whatever the header's
     sticky state is doing. */
  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.syncOffset();
    });
  }

  syncOffset() {
    const offset = this.header ? Math.max(0, Math.round(this.header.getBoundingClientRect().bottom)) : 0;
    if (offset === this.lastOffset) return;
    this.lastOffset = offset;
    document.documentElement.style.setProperty('--collection-bar-top', `${offset}px`);
  }

  setUpFilterToggle() {
    const filters = document.getElementById('main-collection-filters');
    if (!filters) {
      this.filterButton.hidden = true;
      return;
    }

    document.body.classList.add('collection-bar-filters-collapsed');

    this.filterButton.addEventListener('click', () => {
      const open = document.body.classList.toggle('collection-bar-filters-collapsed') === false;
      this.filterButton.setAttribute('aria-expanded', String(open));
    });
  }

  setUpGridToggle() {
    const stored = localStorage.getItem(COLLECTION_BAR_DENSITY_KEY);
    this.density = COLLECTION_BAR_DENSITIES[stored] ? stored : '4';
    this.applyDensity();

    this.gridButton.addEventListener('click', () => {
      this.density = this.density === '4' ? '2' : '4';
      try {
        localStorage.setItem(COLLECTION_BAR_DENSITY_KEY, this.density);
      } catch (error) {
        // Private browsing — the choice just won't persist.
      }
      this.applyDensity();
    });

    /* The theme replaces the grid markup when filters or sorting change. */
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    this.gridObserver = new MutationObserver(() => this.applyDensity());
    this.gridObserver.observe(container, { childList: true, subtree: true });
  }

  applyDensity() {
    this.dataset.density = this.density;
    this.gridButton.setAttribute('aria-pressed', String(this.density === '2'));

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const { desktop, tabletDown } = COLLECTION_BAR_DENSITIES[this.density];
    const wanted = [`grid--${desktop}-col-desktop`, `grid--${tabletDown}-col-tablet-down`];
    const stale = Array.from(grid.classList).filter(
      (name) => /^grid--\d+-col-(desktop|tablet-down)$/.test(name) && !wanted.includes(name)
    );
    const missing = wanted.filter((name) => !grid.classList.contains(name));
    if (!stale.length && !missing.length) return;

    grid.classList.remove(...stale);
    grid.classList.add(...missing);
  }
}

customElements.define('collection-bar', CollectionBar);
